import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {InsightsPeriod} from '../../../../domain/insights-period';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-tenor-selector',
  templateUrl: './tenor-selector.component.html',
  styleUrls: ['./tenor-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule]
})
export class TenorSelectorComponent {
  @Input() tenor: InsightsPeriod;
  @Input() activeTenor: InsightsPeriod;
  @Output() selectTenor = new EventEmitter<InsightsPeriod>();

  onTenorSelect(): void {
    this.selectTenor.emit(this.tenor);
  }
}
